<script setup lang="ts">
const mobileNavOpen = useState('mobileNavOpen', () => false);
</script>
<template>
  <div class="flex relative">
    <div v-if="mobileNavOpen" class="fixed inset-0 bg-gray-900 opacity-50 z-10" @click="mobileNavOpen = false" />
    <AppSideNav overlay-only />
    <div class="flex flex-col flex-grow overflow-y-auto" style="height: 100dvh; padding-top: env(safe-area-inset-top)">
      <AppImpersonationBanner />
      <AppAlert />
      <div class="p-4">
        <slot />
      </div>
    </div>
  </div>
</template>
